import React, { useState } from "react";
import Loader from "../../../components/loaders/loader";
import Button from "../../../components/buttons/button";
import { useTranslation } from "react-i18next";
import TableView from "./playlist-table/table-view";
import TablePaginationCustom from "./playlist-table/table-pagination-custom";
import AddPlaylistModal from "./components/add-playlist-modal";
import { useGetPlaylistQuery } from "../../../store/Reducer/playlist";

const PlaylistView = ({isPlaylist,setIsPlayList,deviceId}) => {
  const { t } = useTranslation();

  const [isEdit, setIsEdit] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const { data, isLoading } = useGetPlaylistQuery({ page: currentPage });



  const openModal = (edit = false, rowData = null) => {
    setIsEdit(edit);
    setSelectedRowData(rowData);
    setIsPlayList(true);
  };

  const closeModal = () => {
    setIsEdit(false);
    setSelectedRowData(null);
    setIsPlayList(false);
  };

  const breadcrumbItems = [
    { label: t("universal_dashboard_text"), to: "/user-dashboard" },
    { label: t("events_breadcurmbs_title") },
  ];

  return (
    <>
      <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 md:space-x-4 py-4">
        <div className="w-full flex justify-between items-center">
          <div className="heading">
            <h1 className="text-2xl sm:text-2xl font-bold text-slate-700 flex items-center">
              Playlist
            </h1>
          </div>

          <Button
            text="Create Playlist"
            type="button"
            className="px-6 text-nowrap"
            onClick={() => openModal(false)}

          />
        </div>
      </div>

      {isLoading ? (
        <div className="pt-16 flex justify-center mt-12 items-center">
          <Loader />
        </div>
      ) : (
        <>
          <TableView
            eventsData={data?.data}
            onEditRow={(rowData) => openModal(true, rowData)}
            searching={Boolean(search)}
          />

          <TablePaginationCustom
            details={data?.pagination || []}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={data?.pagination?.totalPages || 1}
            totalItems={data?.pagination?.totalPlaylists}
          />

          <AddPlaylistModal isOpen={isPlaylist} closeModal={closeModal}   isEdit={isEdit}
        rowData={selectedRowData} deviceId={deviceId} />
        </>
      )}
    </>
  );
};

export default PlaylistView;
